import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogActions, DialogContent, DialogTitle, } from '@mui/material';
const AuthDialog = ({ title, formFields, formActions, extraActions, open, handleSubmit, handleClose, }) => (_jsxs(Dialog, { open: open, onClose: handleClose, PaperProps: {
        sx: {
            minWidth: {
                xs: '90%',
                md: '500px',
            },
        },
    }, children: [_jsx(DialogTitle, { sx: {
                fontWeight: 700,
                fontSize: '1.1rem',
                color: (t) => (t.palette.primary.main),
            }, children: title }), _jsxs("form", { onSubmit: handleSubmit, noValidate: true, children: [_jsx(DialogContent, { children: formFields }), _jsx(DialogActions, { sx: { px: 3 }, children: formActions })] }), extraActions] }));
export default AuthDialog;
//# sourceMappingURL=AuthDialog.js.map